export default "__VITE_ASSET__BuRxOeIS__"